import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, Transition } from "@headlessui/react";
import type { ReactNode } from "react";
import { useState } from "react";

export function BridgedPopover({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const [isShowing, setIsShowing] = useState(false);

  return (
    <Popover className="relative">
      <div
        className="flex items-center"
        onMouseEnter={() => setIsShowing(true)}
        onMouseLeave={() => setIsShowing(false)}
      >
        <FontAwesomeIcon icon={faCircleInfo} className="h-[14px]" />
      </div>
      <Transition
        show={isShowing}
        onMouseEnter={() => setIsShowing(true)}
        onMouseLeave={() => setIsShowing(false)}
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Popover.Panel className="absolute z-10">
          <p className="translate-x-6 -translate-y-4 w-48 border border-primary bg-white dark:bg-gray-900 round p-3 text-xs text-gray-500 dark:text-gray-400 shadow-md text-left">
            {children}
          </p>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}
